// Mobile Growth pipeline: one stage at a time (tabs). Desktop keeps full kanban (lg:flex on all columns).
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "tab"]
  static values = { initialStage: String }

  connect() {
    const stage = this.initialStageValue
    if (typeof stage === "string" && stage.length > 0) {
      this.showStage(stage)
    }
  }

  select(event) {
    const stage = event.currentTarget.dataset.stage
    if (stage) this.showStage(stage)
  }

  showStage(stage) {
    this.panelTargets.forEach((panel) => {
      const on = panel.dataset.stage === stage
      panel.classList.toggle("max-lg:hidden", !on)
    })

    this.tabTargets.forEach((tab) => {
      const on = tab.dataset.stage === stage
      tab.classList.toggle("bg-white", on)
      tab.classList.toggle("dark:bg-gray-700", on)
      tab.classList.toggle("shadow-sm", on)
      tab.classList.toggle("text-gray-900", on)
      tab.classList.toggle("dark:text-white", on)
      tab.classList.toggle("text-gray-600", !on)
      tab.classList.toggle("dark:text-gray-400", !on)
      tab.setAttribute("aria-pressed", on ? "true" : "false")
    })
  }
}
